import { useMutation } from "@tanstack/react-query"
import { websiteAuthService } from "@/api/websiteAuthService"
import { toast } from "sonner"
import { useNavigate } from "react-router-dom"

export const useRegister = () => {
  const navigate = useNavigate()

  return useMutation({
    mutationFn: websiteAuthService.register,
    onSuccess: () => {
      localStorage.removeItem("website_token")
      localStorage.removeItem("customer")
      toast.success("Registered successfully")
      navigate("/website/login")
    },
    onError: (error: any) => {
      localStorage.removeItem("website_token")
      localStorage.removeItem("customer")

      const serverError = error
      if (serverError?.error) {
        const firstError = Object.values(serverError.error)[0] as string[]
        toast.error(firstError[0])
      } else {
        toast.error(serverError?.message || "Failed to register")
      }
    },
  })
}
